"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BlockUIActions = (function () {
    function BlockUIActions() {
    }
    BlockUIActions.START = 'start';
    BlockUIActions.STOP = 'stop';
    BlockUIActions.UPDATE = 'update';
    BlockUIActions.RESET = 'reset';
    BlockUIActions.UNSUBSCRIBE = 'unsubscribe';
    return BlockUIActions;
}());
exports.BlockUIActions = BlockUIActions;



//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/node_modules/ng-block-ui/dist/lib/constants/block-ui-actions.constant.js
// module id = kwd8
// module chunks = 3